import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { payments as paymentsApi } from '@afosto/order/api/Payments';
import { useSnackbar } from 'notistack';
import { useConfirm } from '@afosto/app-components-react/ConfirmDialog';
import translations from './translations';
import { useTransactionContext } from '../../../../../components/TransactionProvider';

const PaymentActions = ({ payment }) => {
  const intl = useIntl();
  const confirm = useConfirm();
  const { enqueueSnackbar } = useSnackbar();
  const { is_refund: isRefund, is_paid: isPaid, secret: paymentSecret } = payment ?? {};
  const { fetchTransaction } = useTransactionContext();

  const executePayment = async () => {
    try {
      const confirmExecuteResponse = await confirm({
        title: intl.formatMessage(translations.confirmExecuteRefund.title),
        description: intl.formatMessage(translations.confirmExecuteRefund.description),
        buttons: [
          {
            label: intl.formatMessage(translations.confirmExecuteRefund.actions.park),
            type: 'cancel',
            variant: 'outlined',
            style: {
              marginRight: 'auto',
            },
          },
          {
            label: intl.formatMessage(translations.confirmExecuteRefund.actions.execute),
            response: 'execute',
            type: 'submit',
            variant: 'contained',
            color: 'primary',
          },
        ],
        catchOnCancel: false,
      });

      if (confirmExecuteResponse === 'execute') {
        await paymentsApi.executePaymentTransaction(paymentSecret);
        enqueueSnackbar(intl.formatMessage(translations.feedback.paymentRefunded), {
          variant: 'success',
        });
        fetchTransaction(true);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        const errorResponse = JSON.parse(error.response.data.message);
        if (errorResponse?.detail) {
          enqueueSnackbar(errorResponse.detail, {
            variant: 'error',
          });
          return;
        }
      }

      enqueueSnackbar(intl.formatMessage(translations.feedback.paymentNotRefunded), {
        variant: 'error',
      });
    }
  };

  if (isRefund && !isPaid) {
    return (
      <Button size="small" variant="outlined" onClick={executePayment}>
        {intl.formatMessage(translations.executeRefund)}
      </Button>
    );
  }

  return null;
};

PaymentActions.propTypes = {
  payment: PropTypes.object,
};

PaymentActions.defaultProps = {
  payment: {},
};

export default PaymentActions;
